import React from "react";
import { TextField, Typography, Box } from "@mui/material";

const Step1AppDetails = ({ appDetails, setAppDetails }) => {
    const handleChange = (field, value) => {
        setAppDetails({ ...appDetails, [field]: value });
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                maxWidth: 800,
                width: "100%",
                mx: "auto",
            }}
        >
            <Typography variant="h6" gutterBottom>
                App Details
            </Typography>
            <Typography variant="body2" sx={{ mb: 3 }}>
                Provide the basic information for your monitoring application. This includes a name that clearly identifies the application and a description explaining its purpose and functionality.
            </Typography>
            <TextField
                label="App Name"
                fullWidth
                value={appDetails.name}
                onChange={(e) => handleChange("name", e.target.value)}
                helperText="Example: Smart City Traffic Monitoring"
                sx={{ mb: 2 }}
            />
            <TextField
                label="App Description"
                fullWidth
                multiline
                rows={4}
                value={appDetails.description}
                onChange={(e) => handleChange("description", e.target.value)}
                helperText="Describe what your app does and its purpose. Example: This app monitors traffic intersections for congestion and accidents."
            />
        </Box>
    );
};

export default Step1AppDetails;
